(function ($) {
  $(document).ready(function () {

    var theModal = $('#simple-reservation-modal').modal();
    $('#simple-reservation-modal-btn').on('click', function () {
      theModal.modal('show');
    });
    $('#simple-reservation-modal-cls').on('click', function () {
      theModal.modal('hide');
    });

    var stripeForms = $('.reserve-form[data-stripe]');
    var stripeData = [];

    stripeForms.each(function () {
      var form = $(this);
      var ticketType = form.data('ticket-type');
      var stripe_key = form.data('stripe');
      var stripe = Stripe(stripe_key);
      var stripe_e = stripe.elements();
      var stripeElementId = '#stripe-card-element-' + ticketType;
      var stripeErrorsId = '#stripe-card-errors-' + ticketType;

      var stripe_cd = stripe_e.create('card', {
        style: {
          base: {
            iconColor: '#666EE8',
            color: '#31325F',
            lineHeight: '40px',
            fontWeight: 300,
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSize: '18px',
            border: "1px solid black",
            '::placeholder': {
              color: '#CFD7E0',
            },
          },
          invalid: {
            color: "#e5424d",
            ":focus": {
              color: "#303238"
            }
          }
        },
        classes: {
          focus: 'is-focused',
          empty: 'is-empty'
        },
        postalCode: true,
      });

      stripe_cd.mount(stripeElementId);
      stripe_cd.on('change', function (event) {
        var displayError = $(stripeErrorsId);
        if (event.error) {
          displayError.html(event.error.message);
        } else {
          displayError.html('');
        }
      });

      stripeData.push({
        ticketType: ticketType,
        stripeElementId: stripeElementId,
        stripeErrorsId: stripeErrorsId,
        stripeCdInstance: stripe_cd,
        stripeInstance: stripe
      });
    });

    function stripeTokenHandler(token, ticketType) {
      var stripeInfo = stripeData.find(function (info) {
        return info.ticketType === ticketType;
      });

      if (stripeInfo) {
        var stripeErrorsId = stripeInfo.stripeErrorsId;
        $(stripeErrorsId).html('');
        reserveFormSubmit(token, ticketType);
      }
    }

    function stripeCreateToken(form, extraData, ticketType) {
      var stripeInfo = stripeData.find(function (info) {
        return info.ticketType === ticketType;
      });

      if (stripeInfo) {
        var stripeInstance = stripeInfo.stripeInstance;
        var stripeCdInstance = stripeInfo.stripeCdInstance;

        stripeInstance.createToken(stripeCdInstance).then(function (result) {
          if (result.error) {
            $(stripeErrorsId).html(result.error.message);
          } else {
            stripeTokenHandler({ stripeToken: result.token.id }, ticketType);
          }
        });
      }
    }

    function reserveFormSubmit(extraData, ticketType) {
      var form = $('.reserve-form[data-ticket-type="' + ticketType + '"]');
      var dataObj = {
        action: 'data_reserve',
        ticket_type: ticketType,
        eventid: $('#eventid').val()
      };

      var tests = form.find('.reserve-field');
      tests.each(function (i) {
        dataObj['id[' + i + ']'] = $(this).attr('id');
        dataObj['label[' + i + ']'] = $(this).data('label');
        dataObj['value[' + i + ']'] = $(this).val();
      });

      for (const [key, value] of Object.entries(extraData)) {
        dataObj[key] = value;
      }

      console.log('dataObj: ', dataObj);

      $.ajax({
        url: plugin_name_ajax_object.ajax_url,
        type: 'post',
        dataType: 'json',
        data: dataObj,
        success: function (result) {
          form.find('.reserve-field').each(function () {
            $(this).val('');
          });
          form.find('.form-submitted.success').remove();
          form.prepend(`
            <div class="form-submitted success">
              We have received your submission!
            </div>
          `);
          form.find('.reserve-field').one('input', function () {
            form.find('.form-submitted.success').remove();
          });
          if ('stripeToken' in extraData) {
            var stripeInfo = stripeData.find(function (info) {
              return info.ticketType === ticketType;
            });
            if (stripeInfo) {
              var stripeErrorsId = stripeInfo.stripeErrorsId;
              $(stripeErrorsId).html('');
            }
          }
        }
      });
    }

    $('.reserve-form').on('submit', function (e) {
      e.preventDefault();
      var form = $(this);
      var ticketType = form.data('ticket-type');
      var hasStripe = form.data('stripe') !== undefined;

      if (hasStripe) {
        stripeCreateToken(form, {}, ticketType);
      } else {
        reserveFormSubmit({}, ticketType);
      }
    });
  });
})(jQuery);